import { z } from "zod";

/** Preferências › Usuários: o administrador adiciona uma pessoa à conta com perfil e senha inicial. */
export const userCreateInput = z.object({
  name: z.string().trim().min(2, "Informe o nome").max(120),
  email: z
    .email("E-mail inválido")
    .max(254)
    .transform((e) => e.toLowerCase()),
  roleId: z.string().min(1, "Escolha o perfil").max(64),
  password: z.string().min(12, "A senha inicial precisa ter 12 caracteres ou mais").max(200),
});
export type UserCreateInput = z.output<typeof userCreateInput>;

export type TenantUserView = {
  id: string;
  name: string;
  email: string;
  roleName: string;
  status: string;
  lastLoginAt: string | null;
};
export type TenantUsersView = { users: TenantUserView[]; roles: { id: string; name: string }[] };
